import { onMounted, onUnmounted } from 'vue';
import { MatchMediaEvent, MediaThreshold } from "webshop-modules";

export function useBreakpointHandler() {
    const mobileBreakpoint = window.matchMedia(MediaThreshold.MOBILE);
    const tabletBreakpoint = window.matchMedia(MediaThreshold.TABLET);
    const desktopBreakpoint = window.matchMedia(MediaThreshold.DESKTOP);

    function handleBreakpointInitialization(): void {
        handleBreakpointChange();
    }

    function handleBreakpointChange(event?: MediaQueryListEvent) {
    }

    function handleMobileChange(event) {
        handleBreakpointChange(event);
    }

    function handleTabletChange(event) {
        handleBreakpointChange(event);
    }

    function handleDesktopChange(event) {
        handleBreakpointChange(event);
    }

    onMounted(() => {
        handleBreakpointInitialization();

        desktopBreakpoint.addEventListener(MatchMediaEvent.CHANGE, handleDesktopChange);
        tabletBreakpoint.addEventListener(MatchMediaEvent.CHANGE, handleTabletChange);
        mobileBreakpoint.addEventListener(MatchMediaEvent.CHANGE, handleMobileChange);
    });

    onUnmounted(() => {
        desktopBreakpoint.removeEventListener(MatchMediaEvent.CHANGE, handleDesktopChange);
        tabletBreakpoint.removeEventListener(MatchMediaEvent.CHANGE, handleTabletChange);
        mobileBreakpoint.removeEventListener(MatchMediaEvent.CHANGE, handleMobileChange);
    });

    return {
        mobileBreakpoint,
        tabletBreakpoint,
        desktopBreakpoint
    };
}
